export const pushStateKey = (appId) => `pk:push:${appId}`;
/** Разбор сохранённого значения (чистая функция для тестов): мусор и чужие формы → null. */
export function parsePushState(raw) {
    if (!raw)
        return null;
    try {
        const v = JSON.parse(raw);
        return v && typeof v.endpoint === "string" && v.endpoint.startsWith("https://") ? { endpoint: v.endpoint, at: typeof v.at === "string" ? v.at : "" } : null;
    }
    catch {
        return null;
    }
}
export function readPushState(appId) {
    try {
        return parsePushState(localStorage.getItem(pushStateKey(appId)));
    }
    catch {
        return null;
    }
}
export function writePushState(appId, endpoint) {
    try {
        localStorage.setItem(pushStateKey(appId), JSON.stringify({ endpoint, at: new Date().toISOString() }));
    }
    catch { /* private mode */ }
}
export function clearPushState(appId) {
    try {
        localStorage.removeItem(pushStateKey(appId));
    }
    catch { /* ignore */ }
}
//# sourceMappingURL=pushState.js.map